export default {
  label: `Помічник з управління<br>рекрутингом`
}
